import React, { useEffect, useState } from "react";
import TagCloud from "TagCloud"; // Ensure this import is correct and TagCloud is installed
import "../../styles/Skill/Skill.scss";
import "../../styles.css"; // Import the generalized CSS styles

const Skill = ({ darkTheme }) => {
  const [hoveredIndices, setHoveredIndices] = useState(new Set());

  useEffect(() => {
    const container = ".tagcloud";
    const texts = [
      "SQL",
      "Python",
      "Machine Learning",
      "Deep Learning",
      "GAN",
      "StreamLit",
      "Flask",
      "Fast API",
      "Docker",
      "MongoDB",
      "GIT",
      "GITHUB",
    ];

    const updateRadius = () => {
      if (window.innerWidth <= 778) {
        return 150; // Adjusted value for smaller screens
      } else {
        return 290; // Default value for larger screens
      }
    };

    const initializeTagCloud = () => {
      const options = {
        radius: updateRadius(),
        maxSpeed: "normal",
        initSpeed: "normal",
        keep: true,
      };

      TagCloud(container, texts, options);
    };

    // Initialize TagCloud on component mount
    if (typeof window !== "undefined") {
      initializeTagCloud();
    }

    // Update TagCloud radius on window resize
    const handleResize = () => {
      const tagCloudElement = document.querySelector(container);
      if (tagCloudElement) {
        tagCloudElement.innerHTML = ""; // Clear the existing TagCloud
        initializeTagCloud(); // Reinitialize TagCloud with updated radius
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const text = "SKILLS.";

  const handleMouseOver = (index) => {
    setHoveredIndices((prev) => new Set(prev.add(index)));
  };

  const handleMouseOut = (index) => {
    // Optional: Remove this function if you want to keep the hover effect persistent
  };

  return (
    <div className={`skill ${darkTheme ? "dark" : "light"}`}>
      <div className="skill__main-container">
        <div className="skill__header" id="skill__heading">
          <h1 className="text-wrapper">
            {text.split("").map((char, index) => (
              <span
                key={index}
                className={hoveredIndices.has(index) ? "gradient-text" : ""}
                onMouseOver={() => handleMouseOver(index)}
                onMouseOut={() => handleMouseOut(index)} // Optional: Remove this if you don't need to reset hover
                style={{ color: darkTheme ? "white" : "black" }}
              >
                {char === " " ? "\u00A0" : char}
              </span>
            ))}
          </h1>
        </div>
        <div className="skill__inner-container">
          <div className="skill__info">
            <div className="skill__details-container">
              <div className="skill__details">
                <h4
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                >
                  Basic
                </h4>
                <ul>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Python</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>C++</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>SQL</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>MongoDB</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Docker</span>
                  </li>
                </ul>
              </div>

              <div className="skill__details">
                <h4
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                >
                  Deep Learning
                </h4>
                <ul>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Artificial Neural Network</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Convolutional Neural Network</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Recurrent Neural Network</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>TensorFlow</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>PyTorch</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>TorchServe</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Object Detection</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Generative Adversarial Network</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* 3D Text Cloud  */}
          <div className="skill__info">
            <div className="skill__details-container"></div>
            <div className="skill__cloud">
              <div
                className="tagcloud"
                data-aos="zoom-in-up"
                data-aos-offset="200"
              ></div>
            </div>
          </div>
          <div className="skill__info">
            <div className="skill__details-container">
              <div className="skill__details">
                <h4
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                >
                  Machine Learning
                </h4>
                <ul>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>NumPy</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Pandas</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Seaborn</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Matplotlib</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Ploty-Express</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Scikit-Learn</span>
                  </li>
                </ul>
              </div>

              <div className="skill__details">
                <h4
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                >
                  Natural Language Processing
                </h4>
                <ul>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>nltk</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>CBOW</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Skipgrams</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>TF-IDF</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Word2vec</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>LSTM</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Transformers</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>BERT</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Generative AI</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Langchain</span>
                  </li>
                </ul>
              </div>
              <div className="skill__details">
                <h4
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                >
                  Version Control Systems
                </h4>
                <ul>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>GitHub</span>
                  </li>
                  <li
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  >
                    <span>Bit Bucket</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skill;
